export const adaptAssistanceProgram = (programData) => {
    return {
        program: programData?.nombre,
        active: programData?.activo,
        programId: programData?.idPrograma,
        subType: programData?.idSubTipoProgramaNavigation?.nombre,
        type: programData?.idSubTipoProgramaNavigation?.idTipoProgramaNavigation?.nombre,
        typeId: programData?.idSubTipoProgramaNavigation?.idTipoPrograma,
        subtypeId: programData?.idSubTipoPrograma,
    }
}

export const adaptAssistanceProgramArray = (
    assistancePrograms
) => {
    return structuredClone(assistancePrograms?.programs?.items)
        ?.map(program => adaptAssistanceProgram(program));
}